"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25 33.75C24.7884 33.7472 24.5796 33.7014 24.3862 33.6155C24.1928 33.5295 24.0189 33.4052 23.875 33.25L10.1667 18.8959C9.87108 18.5864 9.7105 18.1723 9.72027 17.7444C9.72511 17.5326 9.77162 17.3238 9.85715 17.1299C9.94269 16.9361 10.0656 16.761 10.2188 16.6146C10.372 16.4682 10.5525 16.3535 10.7501 16.2769C10.9476 16.2003 11.1584 16.1634 11.3702 16.1682C11.798 16.178 12.2044 16.3573 12.5 16.6667L25 29.8334L37.5 16.6667C37.6446 16.5061 37.8213 16.3777 38.0187 16.2898C38.2161 16.2019 38.4298 16.1564 38.6459 16.1564C38.8619 16.1564 39.0756 16.2019 39.273 16.2898C39.4704 16.3777 39.6471 16.5061 39.7917 16.6667C40.0843 16.9597 40.2486 17.3568 40.2486 17.7709C40.2486 18.1849 40.0843 18.5821 39.7917 18.875L26.125 33.3334C25.9756 33.4755 25.7987 33.5857 25.6053 33.6573C25.4119 33.7289 25.206 33.7605 25 33.75Z",
    fill: fill
  }));
};

exports["default"] = _default;